'use client';

import { useTranslations } from 'next-intl';

import { DocsLinks } from '@/components/how-it-works/docs-links';
import {
  CheckmarkCircle02Icon,
  GiftIcon,
  SquareLock02Icon,
  Wallet01Icon,
} from '@/components/ui/icon/glyphs';
import { InfoModal } from '@/components/ui/info-modal';
import { useGiftFeeBps } from '@/hooks/gifts/use-gift-fee';

interface GiftsHowItWorksDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function GiftsHowItWorksDialog({
  open,
  onOpenChange,
}: GiftsHowItWorksDialogProps): React.ReactNode {
  const t = useTranslations('gift.send.howItWorks');
  const { feeBps } = useGiftFeeBps();
  const feePercent = feeBps / 100;

  return (
    <InfoModal
      open={open}
      onOpenChange={onOpenChange}
      title={t('title')}
      description={t('intro')}
      size="default"
      footer={<InfoModal.Footer cta={t('close')} onClose={(): void => onOpenChange(false)} />}
    >
      <InfoModal.IconList>
        <InfoModal.IconItem icon={GiftIcon} title={t('step1Title')} description={t('step1Body')} />
        <InfoModal.IconItem
          icon={SquareLock02Icon}
          title={t('step2Title')}
          description={t('step2Body')}
        />
        <InfoModal.IconItem
          icon={CheckmarkCircle02Icon}
          title={t('step3Title')}
          description={t('step3Body')}
        />
        <InfoModal.IconItem
          icon={Wallet01Icon}
          title={t('step4Title')}
          description={t('step4Body')}
        />
      </InfoModal.IconList>
      <InfoModal.Callout>{t('feeNote', { feePercent })}</InfoModal.Callout>
      <DocsLinks docsPath="/guides/gifting" />
    </InfoModal>
  );
}
